// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/sea.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section.num7 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(to bottom, rgba(18, 24, 39, 0.9), rgba(18, 24, 39, 0) 30%),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.contact-container {
  display: flex;
  flex-wrap: wrap; /* Ensures that items will wrap on smaller screens */
  gap: 30px;
  max-width: 1000px;
  margin: 20px;
  opacity: 0.89;
}

.contact-info {
  flex: 1 1;
  background-color: #333;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.contact-info h2 {
  margin-bottom: 15px;
  color: #F4CC00;
  font-size: 1.8rem;
}

.contact-info ul {
  list-style: none;
  padding: 0;
}

.contact-info li {
  margin-bottom: 10px;
  font-size: 1rem;
  color: #a3a3a3;
}

.contact-info strong {
  color: #fff;
}

.contact-card {
  flex: 2 1;
  background-color: #333;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 30px;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.contact-card:hover {
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
  transform: translateY(-5px);
}

.contact-card h2 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 1.8rem;
  color: #F4CC00;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contact-form label {
  font-size: 1rem;
  color: #a3a3a3;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.contact-form input:focus,
.contact-form textarea:focus {
  border-color: #007bff;
  outline: none;
}

.contact-form textarea {
  resize: none;
  height: 100px;
}

.contact-form button {
  padding: 10px;
  background-color: #F4CC00;
  color: #333;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s ease;
}

.contact-form button:hover {
  background-color: #E4B300;
}

/* ------------------- Responsive Styles ------------------- */
@media (max-width: 768px) {
  .contact-container {
    flex-direction: column; /* Stack elements vertically */
    align-items: center;
  }

  /* Make both .contact-info and .contact-card take full width */
  .contact-info,
  .contact-card {
    flex: 1 1 100%;
    margin: 0;
    max-width: 800px;
    width: 100%;
  }

  /* Adjust heading sizes for smaller screens */
  .contact-info h2,
  .contact-card h2 {
    font-size: 1.5rem;
  }

  /* Optional: Adjust padding and font-size for inputs, labels, etc. */
  .contact-info,
  .contact-card {
    padding: 20px;
  }

  .contact-form label {
    font-size: 0.9rem;
  }

  .contact-form input,
  .contact-form textarea {
    font-size: 0.9rem;
  }

  .contact-form button {
    font-size: 1rem;
    padding: 8px;
  }
}

/* Example further adjustment for extremely small devices */
@media (max-width: 480px) {
  .contact-info h2,
  .contact-card h2 {
    font-size: 1.2rem;
  }

  .contact-form label {
    font-size: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App/contact.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB;2CACyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe,EAAE,oDAAoD;EACrE,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE;IACE,sBAAsB,EAAE,8BAA8B;IACtD,mBAAmB;EACrB;;EAEA,8DAA8D;EAC9D;;IAEE,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,WAAW;EACb;;EAEA,6CAA6C;EAC7C;;IAEE,iBAAiB;EACnB;;EAEA,oEAAoE;EACpE;;IAEE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,2DAA2D;AAC3D;EACE;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".section.num7 {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n  background: linear-gradient(to bottom, rgba(18, 24, 39, 0.9), rgba(18, 24, 39, 0) 30%),\r\n    url('./images/sea.jpg');\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.contact-container {\r\n  display: flex;\r\n  flex-wrap: wrap; /* Ensures that items will wrap on smaller screens */\r\n  gap: 30px;\r\n  max-width: 1000px;\r\n  margin: 20px;\r\n  opacity: 0.89;\r\n}\r\n\r\n.contact-info {\r\n  flex: 1;\r\n  background-color: #333;\r\n  border-radius: 8px;\r\n  padding: 30px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.contact-info h2 {\r\n  margin-bottom: 15px;\r\n  color: #F4CC00;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.contact-info ul {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.contact-info li {\r\n  margin-bottom: 10px;\r\n  font-size: 1rem;\r\n  color: #a3a3a3;\r\n}\r\n\r\n.contact-info strong {\r\n  color: #fff;\r\n}\r\n\r\n.contact-card {\r\n  flex: 2;\r\n  background-color: #333;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  padding: 30px;\r\n  transition: box-shadow 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.contact-card:hover {\r\n  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.contact-card h2 {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n  font-size: 1.8rem;\r\n  color: #F4CC00;\r\n}\r\n\r\n.contact-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.contact-form label {\r\n  font-size: 1rem;\r\n  color: #a3a3a3;\r\n}\r\n\r\n.contact-form input,\r\n.contact-form textarea {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  font-size: 1rem;\r\n  transition: border-color 0.3s ease;\r\n}\r\n\r\n.contact-form input:focus,\r\n.contact-form textarea:focus {\r\n  border-color: #007bff;\r\n  outline: none;\r\n}\r\n\r\n.contact-form textarea {\r\n  resize: none;\r\n  height: 100px;\r\n}\r\n\r\n.contact-form button {\r\n  padding: 10px;\r\n  background-color: #F4CC00;\r\n  color: #333;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.contact-form button:hover {\r\n  background-color: #E4B300;\r\n}\r\n\r\n/* ------------------- Responsive Styles ------------------- */\r\n@media (max-width: 768px) {\r\n  .contact-container {\r\n    flex-direction: column; /* Stack elements vertically */\r\n    align-items: center;\r\n  }\r\n\r\n  /* Make both .contact-info and .contact-card take full width */\r\n  .contact-info,\r\n  .contact-card {\r\n    flex: 1 1 100%;\r\n    margin: 0;\r\n    max-width: 800px;\r\n    width: 100%;\r\n  }\r\n\r\n  /* Adjust heading sizes for smaller screens */\r\n  .contact-info h2,\r\n  .contact-card h2 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  /* Optional: Adjust padding and font-size for inputs, labels, etc. */\r\n  .contact-info,\r\n  .contact-card {\r\n    padding: 20px;\r\n  }\r\n\r\n  .contact-form label {\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .contact-form input,\r\n  .contact-form textarea {\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .contact-form button {\r\n    font-size: 1rem;\r\n    padding: 8px;\r\n  }\r\n}\r\n\r\n/* Example further adjustment for extremely small devices */\r\n@media (max-width: 480px) {\r\n  .contact-info h2,\r\n  .contact-card h2 {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .contact-form label {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
